export const type = 'mdxJsxTextElement';
